import React,{useEffect} from 'react';
import './Contact.css';
import c1 from '../../data/img/image 60.png';
import c2 from '../../data/img/image 64.png';
import c3 from '../../data/img/image 66.png';
import c4 from '../../data/img/image 68.png';
import c5 from '../../data/img/image 61.png';
import c6 from '../../data/img/image 65.png';
import c7 from '../../data/img/image 67.png';
import socialMedia from '../../data/img/fb.png';
import visaCard from '../../data/img/image 69.png';
import masterCard from '../../data/img/image 70.png';
import bitcoin from '../../data/img/image 71.png';
import taka from '../../data/img/image 72.png';
import bank from '../../data/img/image 73.png';
import Footer from '../Footer/Footer';
import scroll_effect from '../../utils/scroll_effect';
const Contact = () => {
    scroll_effect('.all-country-animation', 1.5)
   
    
    return (
        <div id="contact">
        <section>
            <div className="container">
                <h3 >BVARB.COM CENTRAL CUSTOMER CARE DEPARTMENT</h3>
                <div className="all-country all-country-animation">
                    <div className="country">
                        <img src={c1} alt="" />
                        <span className="number">+44-161-694-8679 (Malay)</span>
                    </div>
                    <div className="country">
                        <img src={c2} alt="" />
                        <span className="number">+44-157-573-0007 (English)</span>
                    </div><div className="country">
                        <img src={c3} alt="" />
                        <span className="number">+44-161-694-8679 (Malay)</span>
                    </div><div className="country">
                        <img src={c4} alt="" />
                        <span className="number">+44-161-694-7167 (Persian)</span>
                    </div><div className="country">
                        <img src={c5} alt="" />
                        <span className="number">+44-282-003-2214 (Chinese)</span>
                    </div>
                    <div className="country">
                        <img src={c6} alt="" />
                        <span className="number">+44-151-541-5251 (Russian)</span>
                    </div>
                    <div className="country">
                        <img src={c7} alt="" />
                        <span className="number">+44-122-883-0284 (Arabic)</span>
                    </div>
                </div>
            </div>

            {/* footer */}
            <Footer/>

            <div className="container">
                <div className="footer-nav">
                    <div>
                        <img src={socialMedia} alt="socialMedia" />
                    </div>
                    <div>
                        <img src={visaCard} alt="visaCard" />
                        <img src={masterCard} alt="masterCard" />
                        <img src={bitcoin} alt="bitcoin" />
                        <img src={taka} alt="bitcoin" />
                        <img src={bank} alt="bank" />
                    </div>
                </div>
            </div>
        </section>
        </div>
    );
};

export default Contact;